"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.date.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var isInTimeRange = function isInTimeRange(_ref) {
  var startTime = _ref.startTime,
      endTime = _ref.endTime,
      now = _ref.now;

  if (startTime && (0, _isValid["default"])(new Date(startTime))) {
    if ((0, _isBefore["default"])(now, new Date(startTime))) return false;
  }

  if (endTime && (0, _isValid["default"])(new Date(endTime))) {
    if (!(0, _isBefore["default"])(now, new Date(endTime))) return false;
  }

  return true;
};
/* 頁面上下架狀態 */


var isPageInvisible = function isPageInvisible(_ref2) {
  var isVisible = _ref2.isVisible,
      startTime = _ref2.startTime,
      endTime = _ref2.endTime,
      now = _ref2.now;
  return (
    /* 有些 page 的 isVisible 會是 undefined，代表它沒有上下架功能，直接顯示 */
    isVisible === false || !isInTimeRange({
      startTime: startTime,
      endTime: endTime,
      now: now
    })
  );
};

var _default = isPageInvisible;
exports["default"] = _default;